import React from 'react';
import Sign from '../Icons/Sign';

const CheckboxCheckedSign = ({ style, }) => <div className="fake-button" style={style}><Sign glyph="CHECKBOX_CHECKED"/></div>;

export default CheckboxCheckedSign;